import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from '../../config/axiosInstance'

/**
 * Get skills list with pagination, sorting, and filtering
 * GET /admin/skills
 */
export const getSkillsListApi = async (data) => {
  const endPoint =
    `/admin/skills` + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

/**
 * Get a single skill by ID
 * GET /admin/skills/:id
 */
export const getSkillByIdApi = async (id) => {
  const endPoint = `/admin/skills/${id}`
  return await axios.get(endPoint, setJwtToken())
}

/**
 * Create a new skill
 * POST /admin/skills
 */
export const addSkillApi = async (data) => {
  const endPoint = `/admin/skills`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

/**
 * Update a skill
 * PUT /admin/skills/:id
 */
export const updateSkillApi = async (id, data) => {
  const endPoint = `/admin/skills/${id}`
  return await axios.put(endPoint, data, setMultiPartHeader())
}

/**
 * Delete a skill
 * DELETE /admin/skills/:id
 */
export const deleteSkillApi = async (id) => {
  const endPoint = `/admin/skills/${id}`
  return await axios.delete(endPoint, setJwtToken())
}

